import { useQuery } from '@tanstack/react-query';
import { CampaignsService } from '../services';

export const getProfessionalCampaignsQueryKey = (professionalId) => [
  'GET_PROFESSIONAL_CAMPAIGNS',
  professionalId,
];

/**
 * One professional's campaign eligibility history, in the order the service
 * returns it. Read-only, so no invalidation surface: `retry: false` keeps a
 * campaign-service outage from stalling the tab behind three retries, and the
 * tab is not worth a refetch every time the admin tabs back to the window.
 */
export const useGetProfessionalCampaigns = (professionalId, options) => {
  const {
    data, error, isError, isLoading, isFetching,
  } = useQuery({
    queryKey: getProfessionalCampaignsQueryKey(professionalId),
    queryFn: () => CampaignsService.getProfessionalCampaigns(professionalId),
    enabled: options?.enabled ?? !!professionalId,
    retry: false,
    refetchOnWindowFocus: false,
  });

  return {
    campaigns: data || [],
    error,
    isError,
    isLoading: isLoading || isFetching,
  };
};
